import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 04/04/18
 */

import styles from './styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol className={styles['header-ol']}>
        <li>
          <b>Pasal 1 : Definisi</b>
          <ol type="1">
            <li>
              <b>Afiliasi</b> adalah pengendali salah satu Pihak, anak
              perusahaan salah satu Pihak atau pihak yang berada dalam satu
              pengendalian dengan salah satu PIhak;
            </li>
            <li>
              <b>Biaya Transaksi</b> adalah biaya yang dikenakan oleh Payment
              Gateway kepada Merchant untuk setiap Transaksi Internet berhasil.
            </li>
            <li>
              <b>Hari Kerja</b> adalah hari selain Sabtu, Minggu dan hari libur
              nasional, di mana bank-bank di Indonesia buka dan operasional
              untuk kegiatan sehari-hari.
            </li>
            <li>
              <b>Layanan Pembayaran</b> adalah jenis-jenis metode pembayaran
              Transaksi Internet yang tersedia di Sistem Pembayaran Internet.
            </li>
            <li>
              <b>Para Pihak</b> adalah Payment Gateway dan Merchant secara
              bersama-sama;
            </li>
            <li>
              <b>Pelanggan</b> adalah pelaku Transaksi POS/VM di Merchant,
              melalui Sistem Pembayaran Internet.
            </li>
            <li>
              <b>Point of Sales (POS)</b> adalah Aplikasi mesin kasir milik
              Vendor POS yang tersambung pada perangkat Android dan/atau IOS
              untuk melakukan pencatatan Transaksi Penjualan di
              outlet-outlet/gerai-gerai Merchant.
            </li>
            <li>
              <b>Refund</b> adalah pengembalian dana Transaksi Internet kepada
              Pelanggan karena pembatalan atas Transaksi Internet tersebut.
            </li>
            <li>
              <b>Sistem Pembayaran Internet </b> adalah sistem pembayaran yang
              dimiliki dan dikelola oleh Payment Gateway, yang menghubungkan
              antara Service Provider, Payment Gateway, dan POS dan/atau Vending
              Machine.
            </li>
            <li>
              <b>Service Provider</b> adalah penyedia jasa metode pembayaran
              selain Bank, yang memiliki kerjasama dan telah terhubung dengan
              Payment Gateway.
            </li>
            <li>
              <b>Transaksi Internet</b> adalah transaksi melalui media
              elektronik yang dilakukan oleh Pelanggan di POS yang terpasang di
              Merchant, dan diproses oleh Sistem Pembayaran Internet.
            </li>
            <li>
              <b>Vending Machine (VM)</b> adalah suatu alat/mesin yang menjual
              barang secara otomatis yang dapat menerima pembayaran melalui
              GO-PAY.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 2 : Proses Pendaftaran dan Persyaratan Merchant</b>
          <ol type="1">
            <li>
              Transaksi Internet hanya dapat dilakukan melalui POS/VM yang
              terpasang di Merchant, dengan Vendor POS/Operator VM sebagaimana
              yang dicantumkan dalam Perjanjian.
            </li>
            <li>
              Merchant berjanji untuk tidak menjual barang atau jasa yang
              melanggar hukum/peraturan perundang-undangan/ketertiban umum
              dan/atau yang secara spesifik dilarang oleh Service Provider.
            </li>
            <li>
              Payment Gateway dapat menolak memberikan layanan kepada Merchant
              dengan kategori sebagai berikut:
              <ol type="1">
                <li>
                  terlibat tindakan kriminal atau melanggar norma hukum, sosial,
                  agama dan moral;
                </li>
                <li>terlibat dalam kelompok atau organisasi terlarang;</li>
                <li>
                  masuk ke dalam daftar hitam Payment Gateway, Service Provider
                  atau POS;
                </li>
                <li>
                  pertimbangan jelas lain yang ditentukan oleh Payment Gateway,
                  Service Provider atau POS.
                </li>
              </ol>
            </li>
            <li>
              Merchant wajib memberikan pemberitahuan tertulis kepada Payment
              Gateway apabila Merchant merubah jenis usaha dan/atau jenis barang
              atau jasa yang ditawarkan, serta dalam hal terjadi perubahan dalam
              susunan kepemilikan, Direksi atau penanggungjawab Merchant, maupun
              perubahan data-data lainnya (termasuk namun tidak terbatas pada
              NPWP), selambat-lambatnya 5 (lima) Hari Kerja setelah terjadinya
              perubahan. Dalam hal Merchant tidak memenuhi kewajibannya ini,
              maka seluruh akibat yang muncul menjadi tanggung jawab Merchant
              sepenuhnya.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 3 : Hak Dan Kewajiban Payment Gateway</b>
          <ol type="1">
            <li>
              Hak Payment Gateway, selain hak-hak yang telah dinyatakan dalam
              pasal-pasal lain Perjanjian ini adalah :
              <ol type="1">
                <li>
                  menerima pembayaran Biaya Transaksi untuk setiap Transaksi
                  Internet yang berhasil;
                </li>
                <li>
                  membatasi, memblokir, memperlambat, menghapus dan/atau
                  mengakhiri layanan Sistem Pembayaran Internet dan mengambil
                  langkah-langkah hukum yang diperlukan apabila Merchant dinilai
                  telah melakukan pelanggaran baik berdasarkan perjanjian ini
                  maupun hukum lainnya yang berlaku;
                </li>
                <li>
                  berhak untuk menggunakan nama, logo, lambang, simbol merek
                  dagang/jasa milik merchant untuk tujuan promosi atau publikasi
                  terkait dengan pelaksanaan Perjanjian ini, tanpa mengalihkan
                  Hak Kekayaan Intelektual yang terkandung didalamnya.
                </li>
              </ol>
            </li>
            <li>
              Kewajiban Payment Gateway, selain kewajiban-kewajiban yang telah
              dinyatakan dalam pasal-pasal lain Perjanjian ini adalah:
              <ol type="1">
                <li>
                  mengelola dan merawat Sistem Pembayaran Internet agar tetap
                  lancar dan operasional;
                </li>
                <li>menyediakan data Transaksi Internet;</li>
                <li>
                  memberikan dukungan teknis atau operasional kepada Merchant
                  apabila diperlukan;
                </li>
                <li>
                  menyiapkan Prosedur Operasi Standar (Standard Operating
                  Procedure) untuk kebutuhan operasional layanan Sistem
                  Pembayaran Internet antara Merchant dan Payment Gateway.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 4 : Hak dan Kewajiban Merchant</b>
          <ol type="1">
            <li>
              Hak Merchant, selain hak-hak yang telah dinyatakan dalam
              pasal-pasal lain Perjanjian ini adalah:
              <ol type="1">
                <li>
                  mendapatkan dukungan teknis maupun operasional dari Payment
                  Gateway;
                </li>
                <li>
                  memasang logo Payment Gateway pada halam pembayaran untuk
                  menunjukan bahwa Merchant menggunakan Sistem Pembayaran
                  Internet milik Payment Gateway, tanpa mengalihkan Hak Kekayaan
                  Intelektual yang terkandung didalamnya;
                </li>
                <li>menerima informasi Data Transaksi Internet; dan</li>
                <li>
                  menerima edukasi terkait akan penyelenggaraan layanan Sistem
                  Pembayaran Internet.
                </li>
              </ol>
            </li>
            <li>
              Kewajiban Merchant, selain kewajiban-kewajiban yang telah
              dinyatakan dalam pasal-pasal lain Perjanjian ini adalah:
              <ol type="1">
                <li>
                  melakukan pembayaran kepada Payment Gateway atas Biaya
                  Transaksi;
                </li>
                <li>
                  menyediakan barang atau produk yang telah dipesan oleh
                  Pelanggan setelah menerima nofitikasi transaksi berhasil;
                </li>
                <li>
                  menyimpan bukti Transaksi Internet selama sekurang-kurangnya
                  24 (dua puluh empat) bulan setelah tanggal terjadinya
                  Transaksi Internet;
                </li>
                <li>memiliki kebijakan Refund; dan</li>
                <li>
                  mematuhi ketentuan dan persyaratan dari masing-masing Layanan
                  Pembayaran yang telah ditetapkan oleh Service Provider.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 5 : Prosedur Operasi Standar</b>
          <ol type="1">
            <li>
              Merchant akan mendapatkan laporan rekapitulasi transaksi harian
              melalui media yang akan diberikan oleh Payment Gateway.
            </li>
            <li>
              Waktu Settlement Transaksi Seluruh Transaksi yang telah
              diotorisasi antara pukul 00.00 sampai dengan 23:59 di hari H oleh
              Service Provider akan diproses settlement pada pukul 15.00 pada
              keesokan harinya (H+1).
            </li>
            <li>
              Penanganan Transaksi Penipuan (Fraud) Payment Gateway berhak
              menahan pencairan dana kepada Merchant dalam hal terdapat
              kecurigaan dari Payment Gateway/POS/Operator VM/Service Provider
              atas adanya penipuan (fraud) yang dilakukan oleh Merchant. Dalam
              hal terdapat kecurigaan tersebut, maka Merchant wajib untuk
              memberikan dokumen-dokumen yang dapat membuktikan bahwa Merchant
              tidak melakukan penipuan (fraud). Dalam hal Merchant tidak
              berhasil membuktikannya maka Payment Gateway berhak untuk
              melakukan Refund atas seluruh Transaksi Internet yang yang telah
              dilakukan dan Payment Gateway dapat melakukan tindakan hukum
              apapun termasuk pengakhiran Perjanjian.
            </li>
            <li>
              Refund
              <ol type="1">
                <li>
                  Ketentuan pelaksanaan serta Jangka waktu pemrosesan Refund
                  akan mengikuti kebijakan dari Service Provider.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 6 : Biaya Transaksi Dan Pembayaran Tagihan</b>
          <ol type="1">
            <li>
              Merchant wajib membayar Biaya Transaksi kepada Payment Gateway
              untuk setiap Transaksi Internet yang berhasil melalui Sistem
              Pembayaran Internet Payment Gateway.
            </li>
            <li>
              Merchant akan dikenakan Biaya Transaksi sebagaimana yang telah
              disepakati, dimana biaya tersebut tidak termasuk biaya
              administrasi Bank dan Pajak yang berlaku.
            </li>
            <li>
              Tata cara pembayaran Biaya Transaksi dan/atau tagihan lainnya
              diatur sebagai berikut :
              <ol type="1">
                <li>
                  Untuk setiap Transaksi Internet yang berhasil, Payment Gateway
                  akan menyimpan dana nilai Transaksi Internet tersebut di
                  rekening Payment Gateway selama jangka waktu 1 (satu) hari
                  kerja setelah tanggal terjadinya Transaksi Internet.
                </li>
                <li>
                  Setelah jangka waktu yang dimaksud berakhir, Payment Gateway
                  akan melakukan proses pencairan dana Transaksi Internet,
                  setelah dipotong Biaya Transaksi ke rekening Merchant di Hari
                  Kerja yang sama.
                </li>
                <li>
                  Pencairan dana Transaksi Internet setelah dipotong biaya
                  transaksi akan dilakukan ke rekening Merchant yang telah
                  disetujui di dalam Perjanjian ini tanpa dikeluarkannya tagihan
                  (invoice) dan/atau bukti penagihan lainnya.
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <b>
            Pasal 7 : Penghentian Sementara Layanan Sistem Pembayaran Internet
          </b>
          <ol type="1">
            <li>
              Payment Gateway dapat setiap saat menghentikan/mematikan Sistem
              Pembayaran Internet untuk sementara waktu dengan pemberitahuan
              selambat-lambatnya 5 (lima) Hari Kerja sebelumnya kepada Merchant.
            </li>
            <li>
              Penghentian layanan Sistem Pembayaran Internet dapat disebabkan
              oleh alasan-alasan sebagai berikut:
              <ol type="1">
                <li>
                  inspeksi, perbaikan, pemeliharaan atau peningkatan sistem;
                </li>
                <li>
                  adanya alasan tertentu berupa melindungi hak-hak dan/atau
                  kepentingan Para Pihak; atau
                </li>
                <li>
                  alasan jelas lain yang ditentukan oleh Payment Gateway, POS,
                  Operator VM atau Service Provider.
                </li>
              </ol>
            </li>
            <li>
              Apabila terdapat gangguan tiba-tiba terhadap Sistem Pembayaran
              Internet akibat kegagalan sistem, jaringan, koneksi internet atau
              alasan lainnya, Payment Gateway akan memberitahu Merchant secara
              tertulis mengenai gangguan ini, serta informasi lanjutan apabila
              gangguan tersebut telah selesai.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 8 : Keamanan dan Perlindungan Informasi</b>
          <ol type="1">
            <li>
              Payment Gateway memiliki sistem dan jaringan yang aman guna
              melindungi informasi yang bersifat sensitif, termasuk namun tidak
              terbatas kepada:
              <ol type="1">
                <li>
                  informasi Transaksi Internet (user id Pelanggan, dan
                  lain-lain); dan
                </li>
                <li>
                  informasi lainnya yang dianggap sensitif oleh Para Pihak.
                </li>
              </ol>
            </li>
            <li>
              Payment Gateway akan menyimpan dan melindungi data Transaksi
              Internet selama 24 (dua puluh empat) bulan setelah tanggal
              terjadinya Transaksi Internet tersebut.
            </li>
            <li>
              Merchant menjamin bahwa Merchant tidak akan melakukan hal-hal
              sebagai berikut:
              <ol type="1">
                <li>
                  melakukan upaya pemecahan kode (reverse engineering) terhadap
                  Sistem Pembayaran Internet;
                </li>
                <li>
                  melakukan hal-hal yang mengakibatkan kerusakan terhadap Sistem
                  Pembayaran Internet dengan sengaja; atau
                </li>
                <li>
                  melakukan hal-hal yang bertujuan untuk mencuri data Transaksi
                  Internet dan Pelanggan.
                </li>
              </ol>
            </li>
            <li>
              Merchant wajib menjamin keamanan data informasi Pelanggan dan
              miliknya. Dalam hal Merchant melanggar ketentuan ini, maka Payment
              Gateway berhak untuk mengnonaktifkan Sistem Pembayaran Internet
              hingga terpenuhinya kewajiban Merchant.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 9 : Jangka Waktu Dan Pengakhiran Perjanjian</b>
          <ol type="1">
            <li>
              Perjanjian ini berlaku selama 1 (satu) tahun sejak tanggal
              ditandatanganinya Perjanjian ini dan akan diperpanjang secara
              otomatis, sepanjang tidak ada pemberitahuan untuk mengakhiri
              Perjanjian sekurang-kurangnya 30 (tiga puluh) hari kalendar
              sebelum tanggal berakhirnya Perjanjian.
            </li>
            <li>
              Para Pihak berhak untuk sewaktu-waktu mengakhiri Perjanjian ini
              apabila terjadi salah satu dari hal-hal:
              <ol type="1">
                <li>
                  Salah satu Pihak melanggar salah satu ketentuan di Perjanjian
                  ini, dan pelanggaran tersebut tidak dapat diperbaiki;
                </li>
                <li>
                  Salah satu Pihak melanggar salah satu ketentuan di Perjanjian
                  ini, dan pelanggaran tersebut dapat diperbaiki, namun Pihak
                  yang melanggar tidak mampu memperbaiki pelanggaran tersebut
                  dalam jangka waktu 30 (tiga puluh) hari kalendar sejak tanggal
                  terjadinya pelanggaran tersebut; atau
                </li>
                <li>
                  Salah satu Pihak pailit, menghentikan layanan serta kegiatan
                  operasionalnya dan izin usahanya dicabut baik sebagian atau
                  secara keseluruhan, memenuhi ketentuan Force Majeure Pasal 15
                  Perjanjian ini, dan oleh karena itu tidak mampu melanjutkan
                  kegiatan usahanya;
                </li>
              </ol>
            </li>
            <li>
              Pengakhiran Perjanjian ini tidak melepaskan Para Pihak dari
              kewajibannya yang timbul sebelum dan/atau pada saat pengakhiran
              Perjanjian ini. Para Pihak wajib menyelesaikan kewajiban dimaksud
              dalam jangka waktu selambat-lambatnya 7 (tujuh) Hari Kerja setelah
              tanggal efektif berakhirnya Perjanjian ini.
            </li>
            <li>
              Dalam pelaksanaan pengakhiran Perjanjian ini, Para Pihak sepakat
              untuk mengesampingkan ketentuan- yang tercantum di dalam Pasal
              1266 dan Pasal 1267 Kitab Undang-Undang Hukum Perdata Indonesia.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 10 : Pernyataan Dan Jaminan</b>
          <ol type="1">
            <li>
              Masing-masing Pihak adalah badan usaha/perorangan yang didirikan
              secara sah berdasarkan hukum yang berlaku di wilayah Republik
              Indonesia dan telah memiliki seluruh persetujuan, ijin serta
              pendaftaran yang dipersyaratkan oleh ketentuan hukum yang berlaku,
              serta tidak sedang dicabut kewenangan bertindaknya menurut hukum
              yang berlaku untuk menjalankan usahanya, termasuk namun tidak
              terbatas kepada pembuatan, penandatanganan serta pelaksanaan
              Perjanjian ini dan dokumen lain yang terkait dengan Perjanjian
              ini.
            </li>
            <li>
              Masing-masing penandatangan Perjanjian ini adalah pihak yang
              berwenang atau wakil yang dalam mengikatkan dirinya atau badan
              usahanya (baik badan hukum maupun bukan badan hukum); dalam hal
              ternyata penanda tangan bukan pihak yang berwenang atau wakil yang
              sah, maka penandatangan bertanggung jawab secara pribadi.
            </li>
            <li>
              Para Pihak menjamin bahwa dokumen yang diberikan kepada pihak
              lainnya adalah merupakan dokumen resmi, asli, sah, masih berlaku
              dan setiap informasi yang tercantum dalam dokumen tersebut adalah
              benar, sesuai dengan keadaan sebenarnya dan bukan merupakan
              rekayasa maupun tipu muslihat atau kebohongan serta sesuai dengan
              ketentuan atau peraturan yang berlaku.
            </li>
            <li>
              Para Pihak dengan ini dan untuk seterusnya dikemudian hari
              membebaskan dan melepaskan Pihak lainnya dari segala gugatan,
              tuntutan atau tagihan dari siapapun yang tidak langsung
              berhubungan dengan Perjanjian ini.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 11 : Domisili Hukum dan Penyelesaian Sengketa</b>
          <ol type="1">
            <li>
              Perjanjian ini diatur dan tunduk pada hukum yang berlaku di Negara
              Republik Indonesia.
            </li>
            <li>
              Apabila dalam pelaksanaan Perjanjian ini terjadi perbedaan
              pendapat dan/atau penafsiran maupun terjadi perselisihan diantara
              Para Pihak dalam Perjanjian ini, maka Para Pihak sepakat untuk
              menyelesaikannya secara musyawarah dengan itikad baik untuk
              mencapai mufakat. Apabila musyawarah mufakat tidak tercapai, maka
              Para Pihak sepakat memilih kedudukan hukum yang tetap dan
              seumumnya di Kantor Kepaniteraan Pengadilan Negeri Jakarta Selatan
              di Jakarta sebagai sarana penyelesaian perselisihan tersebut.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 12 : Kerahasiaan</b>
          <ol type="1">
            <li>
              Para Pihak sepakat bahwa pertukaran informasi yang muncul karena
              Perjanjian ini dikategorikan sebagai rahasia dan untuk itu Para
              Pihak sepakat untuk saling menjaga kerahasiaan informasi tersebut
              terbatas pada masing-masing pihak beserta dengan afiliasinya dan
              dalam rangka pelaksanaan Perjanjian ini, kecuali telah mendapatkan
              izin tertulis dari salah satu pihak lainnya dan/atau informasi
              tersebut telah berlaku dan diketahui secara umum.
            </li>
            <li>
              Selama Perjanjian ini berlaku maupun setelah berakhirnya
              Perjanjian ini, Para Pihak dan semua pihak yang bekerja pada/untuk
              Para Pihak berikut afiliasinya wajib menjaga kerahasiaan data
              dan/atau informasi dalam bentuk apapun mengenai Pelanggan baik
              yang diperoleh dari pihak lainnya maupun dari Transaksi Internet
              melalui Sistem Pembayaran Internet baik yang termasuk sebagai
              rahasia Bank dan/atau Para Pihak, ataupun hal-hal yang wajib dan
              sepatutnya dirahasiakan kepada siapapun.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 13 : Keadaan Memaksa (Force Majeure)</b>
          <ol type="1">
            <li>
              Yang dimaksud dengan Force Majeure adalah suatu peristiwa atau
              keadaan yang terjadi di luar kekuasaan atau kemampuan salah satu
              atau Para Pihak, yang mengakibatkan salah satu atau Para Pihak
              tidak dapat melaksanakan hak-hak dan/atau kewajiban-kewajiban
              sesuai dengan ketentuan-ketentuan di dalam Perjanjian ini,
              termasuk namun tidak terbatas kepada kebakaran, tidak berfungsinya
              tenaga listrik untuk jangka waktu lama, putusnya koneksi internet,
              bencana alam, peperangan, aksi militer, huru-hara, malapetaka,
              pemogokan, epidemi, dan kebijaksanaan maupun peraturan Pemerintah
              atau penguasa setempat yang secara langsung dapat mempengaruhi
              pemenuhan pelaksanaan Perjanjian ini.
            </li>
            <li>
              Dalam hal terjadi Force Majeure, Pihak yang mengalami peristiwa
              yang dikategorikan sebagai Force Majeure wajib memberikan
              pemberitahuan secara tertulis tentang hal tersebut kepada Pihak
              lainnya selambat-lambatnya 7 (tujuh) hari terhitung sejak tanggal
              terjadinya Force Majeure tersebut, karenanya Para Pihak dengan ini
              menjadi tidak bertanggung jawab atas kelalaian atau keterlambatan
              pelaksanaan seluruh atau sebagian Perjanjian ini.
            </li>
            <li>
              Segala permasalahan yang timbul sebagai akibat dari terjadinya
              Force Majeure tersebut akan diselesaikan secara musyawarah oleh
              Para Pihak. Dalam hal Force Majeure berkanjut terus-menerus sampai
              dengan 30 (tiga puluh) hari kalender, maka pihak yang tidak
              mengalami Force Majeure dapat mengakhiri Perjanjian ini.
            </li>
          </ol>
        </li>

        <li>
          <b>Pasal 14 : Ketentuan Lainnya</b>
          <ol type="1">
            <li>
              <b>Lampiran.</b> Segala Lampiran, Addendum, Surat Komunikasi,
              serta dokumen-dokumen lainnya yang dibuat berdasarkan atau
              sehubungan dengan Perjanjian ini, merupakan bagian integral dari
              dan menjadi lampiran yang tidak terpisahkan dari Perjanjian ini.
            </li>
            <li>
              <b>Perubahan.</b> Perjanjian ini tidak boleh diubah atau ditambah
              kecuali disetujui oleh Para Pihak dan termaktub dalam perjanjian
              formal yang ditandatangani oleh Para Pihak.
            </li>
            <li>
              <b>Addendum.</b> Hal-hal yang tidak atau belum diatur dalam atau
              perubahan atas Perjanjian ini, akan diatur kemudian melalui
              addendum yang disepakati dan ditandatangani oleh Para Pihak;
              addendum mana menjadi bagian integral dan menjadi lampiran yang
              tidak terpisahkan dari Perjanjian ini.
            </li>
            <li>
              <b>Pelepasan Hak.</b>Dalam hal terjadi kegagalan, penundaan atau
              keterlambatan oleh salah satu Pihak dalam melaksanakan haknya atau
              menuntut pemenuhan kewajiban dari Pihak lainnya berdasarkan
              Perjanjian ini, maka kegagalan, penundaan atau keterlambatan
              tersebut bukan merupakan pelepasan hak oleh pihak tersebut untuk
              dikemudian hari melaksanakan haknya atau menuntut pemenuhan
              kewajiban pihak lainnya berdasarkan Perjanjian ini.
            </li>
            <li>
              <b>Pengalihan.</b> Perjanjian ini mengikat dan dibuat untuk
              kepentingan dari setiap Pihak dan penerima dan/atau pengganti
              haknya masing-masing, akan tetapi dapat dialihkan sewaktu-waktu
              kepada afiliasi Para Pihak dengan pemberitahuan sebelumnya kepada
              Pihak lainnya dan karenanya Pihak lainnya setuju untuk bekerjasama
              atas hal tersebut.
            </li>
            <li>
              <b>Bahasa.</b> Perjanjian ini dibuat dalam 2 bahasa, Bahasa
              Indonesia dan Bahasa Inggris. Dalam hal terjadi perselisihan
              penafsiran dari istilah maupun hasil penerjemahan, maka ketentuan
              dalam Bahasa Indonesia yang akan berlaku.
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default Indonesia;
